"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const toggle_head_1 = require("./toggle-head");
const S = require("./info-pane-toggle.styles");
exports.InfoPaneToggle = function InfoPaneToggle(props) {
    return (React.createElement(S.StyledToggle, null,
        React.createElement(toggle_head_1.ToggleHead, { name: props.name, enabled: props.enabled }, props.head),
        props.enabled && React.createElement(S.StyledToggleBody, null, props.children)));
};
//# sourceMappingURL=info-pane-toggle.js.map